export const getBaseUrl = () => `https://${getDomain()}`
export const getDomain = () => process.env.GATSBY_DOMAIN
export const getSignupUrl = () =>
  process.env.GATSBY_IRIS_SIGNUP_URL || `https://signup.${getDomain()}/`
export const getAccountUrl = () =>
  process.env.GATSBY_IRIS_ACCOUNT_URL || `https://account.${getDomain()}/`
